import styled from 'styled-components';
import SVG from 'react-inlinesvg';

import { Twirl } from '../../../../../assets';
import { DRAFT, LIVE, FINISHED, PICKED } from '../../../utils/constants';

import { useScrollContext } from '../../../contexts/ScrollContext.jsx';

import DraftPrizeBanner from './DraftPrizeBanner.jsx';
import LivePrizeBanner from './LivePrizeBanner.jsx';
import FinishedPrizeBanner from './FinishedPrizeBanner.jsx';
import PickedPrizeBanner from './PickedPrizeBanner.jsx';

export const PrizeBanner = ({ prize }) => {
  const { prizeRef } = useScrollContext();

  return (
    <Container ref={prizeRef}>
      {prize.status === DRAFT && <DraftPrizeBanner prize={prize} />}
      {prize.status === LIVE && <LivePrizeBanner prize={prize} />}
      {prize.status === FINISHED && <FinishedPrizeBanner />}
      {prize.status === PICKED && <PickedPrizeBanner />}
      <IconWrapper>
        <TwirlIcon src={Twirl} />
      </IconWrapper>
    </Container>
  );
};

const Container = styled.div``;

const IconWrapper = styled.div`
  text-align: center;
  margin: 5px 0;
`;
const TwirlIcon = styled(SVG)``;
